// tslint:disable:no-http-string
import * as React from 'react';
import Linkify from 'react-linkify';
import { Link, SingleValueComponent } from 'ui';
import tlds from 'tlds';

export const linkify = require('linkify-it')();

linkify.tlds(tlds);
linkify   
  .add('file:', 'http:')              // Add `file:` protocol  
  .add('ftps:', 'http:')              // Add `ftps:` protocol  
  .add('mailto:', null)               // Disable `mailto:` protocol    
  .set({ fuzzyLink: false,            // Don't recognize URL-s without http(s):// head.
         fuzzyEmail: false });        // Don't recognize emails without mailto

export interface DisplayTextWithLinksProps extends Partial<SingleValueComponent<string>>{
  text: string;
  className?: string;
  linkify?: boolean;
}

export class DisplayTextWithLinks extends React.Component<DisplayTextWithLinksProps, any> {

  public static defaultProps: Partial<DisplayTextWithLinksProps> = {
    linkify: true
  };

  private renderLink = (decoratedHref: string, decoratedText: string, key: number) => {
    return (
      <Link url={decoratedHref} key={key}>
        {decoratedText}
      </Link>);
  }

  private matchLinks = (text: string): object[] => {
    return linkify.match(text);
  }

  private linkifyValidUrls = (text: string) => {
    return this.props.linkify ? 
      <Linkify matchDecorator={this.matchLinks} componentDecorator={this.renderLink}>{text}</Linkify> : 
      text;
  } 

  public render() {    
    
    return (
      this.props.text ? 
        <div id={this.props.componentId} className={this.props.className}>
          {this.linkifyValidUrls(this.props.text)}
        </div> : null
    );}
}
